



























import {
  computed,
  defineComponent,
  reactive,
  ref,
  Ref,
  watch,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';

import getCashflowCategories from '@/gql/cashflow/getCashflowCategoriesForSelector.gql';

interface PaymentAccount {
  id: string;
  code: string;
  name: string;
  type: string;
}

const CashflowCategoryWithPaymentAccount = defineComponent({
  props: {
    value: {
      default() {
        return {
          cashflowCategory: '',
          paymentAccount: '',
        };
      },
    },
    showLabel: { default: true },
    cashflowCategoriesVariables: {},
  },
  setup(props: any, { emit }: any) {
    const selectedCategory = reactive({ id: -1 });
    const selectedCategoryId: Ref<string> = ref('');

    const selectedPaymentAccount: Ref<string> = ref('');
    const paymentAccountsList: Ref<string[]> = ref([]);
    const paymentAccountsDisplay: Ref<string[]> = ref([]);

    const cashflowCategoriesDisplay: Ref<any> = ref([]);
    const cashflowCategoriesList: Ref<any> = ref([]);
    const cashflowCategoriesPage = ref(1);
    const { result: getCashflowCategoriesResult, loading: cashflowCategoriesLoading } = useQuery(getCashflowCategories, computed(() => ({
      page: cashflowCategoriesPage.value,
      first: 100,
      ...props.cashflowCategoriesVariables,
    })), () => ({ fetchPolicy: 'network-only' }));

    const cashflowCategoriesResult = useResult(getCashflowCategoriesResult, [], (data) => data.cashFlowCategories.data);

    function selectCategoryHandler($event: any, isEmit = true) {
      const cashflowCategory = cashflowCategoriesResult.value.find((category: { id: string; name: string }) => category.id === $event);
      paymentAccountsList.value = [];
      paymentAccountsDisplay.value = [];
      // eslint-disable-next-line
      cashflowCategory?.paymentAccounts.forEach((paymentAccount: PaymentAccount) => {
        paymentAccountsList.value.push(paymentAccount.id);
        paymentAccountsDisplay.value.push(paymentAccount.name);
      });
      if (isEmit) {
        emit('input', {
          cashflowCategory: $event,
          paymentAccount: null,
        });
      }
    }

    watch(() => cashflowCategoriesResult.value, (newVal, oldVal) => {
      if (!cashflowCategoriesLoading.value && cashflowCategoriesResult.value.length > 0 && newVal !== oldVal) {
        cashflowCategoriesList.value = [''];
        cashflowCategoriesDisplay.value = ['เลือกประเภท'];

        cashflowCategoriesResult.value.forEach((category: { id: string; name: string }) => {
          cashflowCategoriesList.value.push(category.id);
          cashflowCategoriesDisplay.value.push(category.name);
        });
        if (props.value?.cashFlowCategory !== '') {
          [selectedCategoryId.value] = cashflowCategoriesList.value;
        }
        // if (props.value.paymentAccount !== '') console.log('TEST');
      }
    });

    watch(() => props.value.paymentAccount, (newVal, oldVal) => {
      if (props.value.paymentAccount !== selectedPaymentAccount.value && newVal !== oldVal) {
        selectedCategoryId.value = props.value.cashflowCategory;
        selectCategoryHandler(selectedCategoryId.value, false);
        selectedPaymentAccount.value = props.value.paymentAccount;
      }
    });

    watch(() => selectedCategoryId.value, (newVal, oldVal) => {
      if (props.value.cashflowCategory !== selectedCategoryId.value && newVal !== oldVal) {
        selectedCategoryId.value = props.value.cashflowCategory;
        selectCategoryHandler(selectedCategoryId.value, false);
        selectedCategoryId.value = props.value.cashflowCategory;
      }
    });

    // onMounted(() => {
    //   selectCategoryHandler(props.value.cashflowCategory, props.value.paymentAccount);
    // });

    function selectPaymentAccountHandler($event: any) {
      emit('input', {
        cashflowCategory: props.value.cashflowCategory,
        paymentAccount: $event,
      });
    }

    return {
      selectedCategory,
      selectedCategoryId,

      cashflowCategoriesList,
      cashflowCategoriesDisplay,
      selectCategoryHandler,

      selectedPaymentAccount,
      paymentAccountsList,
      paymentAccountsDisplay,
      selectPaymentAccountHandler,
    };
  },
});

export default CashflowCategoryWithPaymentAccount;
